import React, { useState } from "react";
import CountyEngine from "./CountyEngine";
import GrowthPriorities from "./GrowthPriorities";
import AvailabilityPanel from "./AvailabilityPanel";
import FCPipeline from "./FCPipeline";
import ContentIdeasPanel from "./ContentIdeasPanel";
import GrowthFunnel from "./GrowthFunnel";

const SUBTABS = [
  { key: "counties", label: "County Engine" },
  { key: "priorities", label: "Priorities" },
  { key: "availability", label: "Availability" },
  { key: "fc", label: "Family Caregiver" },
  { key: "content", label: "Content" },
  { key: "funnel", label: "Funnel & SEO" },
];

const GrowthPanel = () => {
  const [sub, setSub] = useState("counties");
  return (
    <div data-testid="growth-panel">
      <div className="inline-flex flex-wrap rounded-full bg-white border border-slate-200 p-1 shadow-sm mb-6">
        {SUBTABS.map((t) => (
          <button
            key={t.key}
            data-testid={`growth-subtab-${t.key}`}
            onClick={() => setSub(t.key)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${sub === t.key ? "bg-[#0E5A72] text-white" : "text-slate-600 hover:text-[#0E5A72]"}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {sub === "counties" && <CountyEngine />}
      {sub === "priorities" && <GrowthPriorities />}
      {sub === "availability" && <AvailabilityPanel />}
      {sub === "fc" && <FCPipeline />}
      {sub === "content" && <ContentIdeasPanel />}
      {sub === "funnel" && <GrowthFunnel />}
    </div>
  );
};

export default GrowthPanel;
